import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HasId } from "../../model/generics";
import { IQueryFilter, QueryResult } from "../../model/query.filter.class";
import { User } from "../../model/user/user.model";
import { createUrl, queryToParams } from "../api.util";
import { GenericApi } from "../generic.api";

// Convenience Type
type T = User;
type I = User;

@Injectable({
  providedIn: "root",
})
export class UserApi extends GenericApi<T> {
  public path = "user";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  readInternalUser(id:number): Observable<{id:number;firstName:string;lastName:string;email:string;enabled:boolean;roleIds:number[]}> {
    return this.httpClient.get<{id:number;firstName:string;lastName:string;email:string;enabled:boolean;roleIds:number[]}>(createUrl(this.path,'internal-admin',id));
  }
  saveInternalUser(input: {id?:number;firstName:string;lastName:string;email:string;enabled:boolean;roleIds:number[]}): Observable<{id:number;created:boolean;setupEmail?:'sent'|'failed'}> {
    return this.httpClient.post<{id:number;created:boolean}>(createUrl(this.path,'internal-admin'),input);
  }
  get = (id: number | string): Observable<T & HasId<T>> => {
    return this.httpClient.get<T & HasId<T>>(createUrl(this.path, id));
  };

  list = (query: IQueryFilter): Observable<QueryResult<T & HasId<I>>> => {
    return this.httpClient.get<QueryResult<T & HasId<I>>>(createUrl(this.path), {
      params: queryToParams(query),
    });
  };

  public getUsersByCurrentUserId(query: IQueryFilter): Observable<QueryResult<T>> {
    return this.httpClient.get<QueryResult<T>>(createUrl(this.path, `by-current-user`), {
      params: queryToParams(query),
    });
  }

  public getUsersByDeal(dealExternalId: string): Observable<QueryResult<T>> {
    return this.httpClient.get<QueryResult<T>>(createUrl(this.path, `deal-user/${dealExternalId}`));
  }

  public getUserByUUID(uuid: string): Observable<T> {
    return this.httpClient.get<T>(createUrl(this.path, `uuid/${uuid}`));
  }
}
